module.exports = __webpack_public_path__ + "static/morgan-howson-56c2fffd58595ee17189db26d942b19c.png";